import { fetcher } from '@commenda/utils';
import { RootfiSyncDatamodels, IntegrationWebhookType } from '@prisma/client';

export interface TriggerWebhookReplayBody {
  corporation_id: number;
  rootfi_company_id: number;
  data_models?: RootfiSyncDatamodels[];
  webhook_types?: IntegrationWebhookType[];
}

export async function triggerWebhookReplay(
  body: TriggerWebhookReplayBody
): Promise<{
  success: boolean;
  data?: unknown;
  error?: unknown;
}> {
  try {
    const response = await fetcher(
      `integration-sync/webhooks/data-model-changes/replay`,
      {
        method: 'POST',
        body,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error triggering webhook replay:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to trigger webhook replay',
      };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to trigger webhook replay';
    console.error('Failed to trigger webhook replay:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}

